// @ts-nocheck

import fallbackSportIcon from '../../sports/FallBack.png';

import pictoFreebets from './common_freebets.png';
import pictoOdd from './cote_picto.png';
import footerGradient from './gradient.png';
import logoWina from './logoWinamax.png';
import pictoStake from './pieces_fond_noir.png';
import whiteWinamax from './whiteWinamax.png';

export default {
  logoWina,
  whiteWinamax,
  pictoFreebets,
  pictoOdd,
  pictoStake,
  footerGradient,
  fallbackSportIcon,
};
